export const MAX_IMAGE_SIZE = 2_000_000
export const SUPPORTED_IMAGE_TYPES = ['image/jpg', 'image/jpeg', 'image/png']
export const MAX_KNOWLEDGEBASE_FILE_SIZE = 10_000_000
